<template>
  <div class="overlay" @click.stop="toggleMenu()">
    <div class="user-menu" @click.stop="">
      <div class="user-menu__user-name">{{ `${user.Nombre} ${user.Apellido}` }}</div>
      <div class="user-menu__actions">
        <span><i class="material-icons">key</i>{{ $t('nav.changePassword') }}</span>
        <span class="logOut" @click="logout()"><i class="material-icons">logout</i>{{ $t('nav.LOG_OUT') }}</span>
      </div>
    </div>
  </div>

</template>

<script>
import { inject, computed } from "@vue/runtime-core";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
// import Loader from "./Loader.vue";

export default {
    setup(_, { emit }) {
        const router = useRouter();
        const store = useStore();
        const route = useRoute()
        const userMenuActive = inject("userMenuActive");
        const user = computed(() => store.getters.manageUser_user);
        const modalSwitchRole = ref({
          active: false,
          error: false,
          awaitRequest: false,
          newRoleAssigned: undefined
        });
        function toggleMenu() {
            emit("closeUserMenu");
        }
        async function logout() {
            await store.dispatch("manageUser_disabled");
            router.push("/login");
            userMenuActive.value = false;
        }
        async function pickRole(role) {
            if (modalSwitchRole.value.awaitRequest)
                return;
            try {
                modalSwitchRole.value.error = false;
                modalSwitchRole.value.awaitRequest = true;
                modalSwitchRole.value.newRoleAssigned = role
                const delay = ms => new Promise(res => setTimeout(res, ms));
                await delay(2000);
                await store.dispatch("manageUser_pickRole", role);
                modalSwitchRole.value.awaitRequest = false;
                router.go(route.fullPath)
            }
            catch (error) {
                console.log(error);
                modalSwitchRole.value.error = true;
                modalSwitchRole.value.functionFinished = true
                modalSwitchRole.value.awaitRequest = false;
            }
        }
        return {
            toggleMenu,
            logout,
            user,
            modalSwitchRole,
            pickRole
        };
    },
    // components: { Loader }
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.overlay {
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2500;
  background-color: transparent;
  .user-menu {
    position: fixed;
    max-width: 200px;
    top: 55px;
    right: 0;
    margin: 0 6px 0 0;
    padding: 8px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    border-radius: 0;
    background-color: #fff;
    box-shadow: -2px 3px 3px 0px rgba(0, 0, 0, 0.1);
    z-index: 20;
    &__user-name {
      padding: 20px 0;
      border-bottom: 1px solid rgba(96, 96, 96, 0.3);
      font-weight: 600;
      color: $green;
      text-align: center;
    }
    &__actions {
      padding-top: 12px;
      padding-bottom: 6px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding-left: 8px;
      span {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        .material-icons {
          position: static;
        }
      }
      .logOut {
        i {
          transform: rotate(180deg);
        }
        font-weight: 600;
      }
    }
  }
}

.modal{
  background-color: #fff;
  max-width: none;
  width: fit-content;
  padding: 24px 48px;
}

.pickRole{
  h3{
    font-size: 22px;
    font-weight: 700;
  }
  h2{
    font-size: 16px;
    font-weight: 500;
  }
  width: 100%;
  padding-bottom: 24px;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  gap: 12px;
  &__roles{
    width: 100%;
  }
  &__role{
    background: linear-gradient(to right, rgba(189, 228, 228, 0.5) 50%, $lightgray 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    transition: background-position 2s ease-out;
    &--selected{
      background: rgba(189, 228, 228, 0.5);
      color: #009696;
    }
    &--newRoleAnimation{
      color: $green;
      animation-name: newRoleLoader;
      animation-duration: 2s;
      animation-fill-mode: forwards;
      @keyframes newRoleLoader {
        from{
          background-position: right bottom;
          color: $black;
        }
        to {
          background-position: left bottom;
          color: $green;
        }
      }
    }
  }
}


</style>